import React from 'react';
import { Outlet } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import adminAntdTheme from '../theme/adminAntdTheme.js';

const AdminLayout = () => (
  <ConfigProvider theme={adminAntdTheme}>
    <div className="admin-shell">
      <Outlet />
    </div>
  </ConfigProvider>
);

export default AdminLayout;
